import { combineReducers } from "redux";
import Attendance from "./attendance/attendance-duck";
import Document from "./document/document-duck";
import Lobby from "./lobby/lobby-duck";
import Location from "./location/location-duck";
import MultipleRealms from "./multiple-realms/multiple-realms-duck";
import Nps from "./nps/nps-duck";
import Process from "./process/process-duck";
import Readers from "./readers-tags/readers/readers-duck";
import Tags from "./readers-tags/tags/tags-duck";
import Report from "./report/report-duck";
import UserSession from "./user-session/user-session-duck";
import Users from "./users/users-duck";
import VehicleDashboard from "./vehicle-dashboard/vehicle-dashboard-duck";

export default combineReducers({
  UserSession,
  Lobby,
  Report,
  Location,
  Users,
  Document,
  Process,
  Attendance,
  VehicleDashboard,
  MultipleRealms,
  Nps,
  Tags,
  Readers,
});
